import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
import Test from './Test.vue'
import ViewSheet from './ViewSheet.vue'
import { StockInOrderMaterialServiceProxy, WarehousingDTO } from '@/service-proxies/app-v2/wms.service-proxies'
import { MaterialFieldSettingServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import { downloadGET } from '@/api/api';
import { canPreviewList, previewMode } from '@/utils/commonDef';
import { downloadFile, readAsText,readAsDataURL } from '@/utils';
const siomsp = new StockInOrderMaterialServiceProxy()
const mfssp = new MaterialFieldSettingServiceProxy()

@Component({
  components: {
    Test,
    ViewSheet
  }
})
export default class Alarm extends Vue{
  extendFieldList = []
  get columns() {
    let extendCols = []
    this.extendFieldList.map(item => {
      if (item.isDisplay === 1) {
        extendCols.push({
          title: item.name,
          dataIndex: item.code,
          width: 100,
          ellipsis: true
        })
      }
    })
    return [
      {
        title: this.$t('page_material_warehousing_material_name'),
        dataIndex: 'materialName',
        ellipsis: true,
        key: 'materialName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_material_code'),
        dataIndex: 'materialCode',
        ellipsis: true,
        key: 'materialCode',
        width: 150,
      },
      {
        title: this.$t('page_business_material_1'),
        dataIndex: 'materialStuff',
        ellipsis: true,
        key: 'materialStuff',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_specifications'),
        dataIndex: 'materialStandardModel',
        ellipsis: true,
        key: 'materialStandardModel',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_material_type'),
        dataIndex: 'materialTypeName',
        ellipsis: true,
        key: 'materialTypeName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_remark'),
        dataIndex: 'remark',
        ellipsis: true,
        key: 'remark',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_totalNum'),
        dataIndex: 'totalNum',
        ellipsis: true,
        key: 'totalNum',
        width: 150,
      },
      {
        title: this.$t('page_plan_delivery_quantity'),
        dataIndex: 'stockOutNum',
        ellipsis: true,
        key: 'stockOutNum',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_stockInNum'),
        dataIndex: 'stockInNum',
        ellipsis: true,
        key: 'stockInNum',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_unit'),
        dataIndex: 'materialUnit',
        ellipsis: true,
        key: 'materialUnit',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_price'),
        dataIndex: 'price',
        ellipsis: true,
        key: 'price',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_isMustCheck'),
        dataIndex: 'fileName',
        ellipsis: true,
        key: 'fileName',
        width: 150,
        customRender: (fileName,record) => {
          return record.testResult == null ? this.$t('page_material_warehousing_to_wait_test') : this.$t('page_plan_finish')
        },
      },
      {
        title: this.$t('page_material_warehousing_to_check'),
        dataIndex: 'isMustCheck',
        ellipsis: true,
        key: 'isMustCheck',
        width: 150,
        customRender: (item) => {
          return item == 1 ? this.$t('yes') : this.$t('no')
        },
      },
      {
        title: this.$t('page_material_warehousing_testResult'),
        dataIndex: 'testResult',
        ellipsis: true,
        key: 'testResult',
        width: 150,
        customRender: (item) => {
          return item == null ? "" : (item == 1 ? this.$t('page_log_management_success') : this.$t('page_log_management_fail'))
        },
      },
      {
        title: this.$t('page_material_warehousing_area'),
        dataIndex: 'areaName',
        ellipsis: true,
        key: 'areaName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_location'),
        dataIndex: 'locationName',
        ellipsis: true,
        key: 'locationName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_materialStatus'),
        dataIndex: 'materialStatus',
        ellipsis: true,
        key: 'materialStatus',
        width: 150,
        customRender: (item) => {
          return item == 1 ? this.$t('yes') : this.$t('no')
        },
      },
      {
        title: this.$t('page_warehousing_status'),
        dataIndex: 'materialStatus1',
        ellipsis: true,
        key: 'materialStatus1',
        width: 150,
        customRender: (item,record) => {
          return record.materialStatus == 1 ? this.$t('page_plan_finish') : this.$t('page_not_warehoused')
        },
      },
      ...extendCols
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<any>;
  @Prop({ default: 300 }) readonly height: Number;
  selectedRowKeys = []
  testVisible = false
  viewVisible = false
  Rowkey = ""
  currentRow:any = {}
  fileInfo = {}
  showFileInfo = false
  previewEncode = "UTF-8"
  previewMode = "text"
  txtBlob = "" // txt文件流
  content = ""
  previewLoading = false
  canCheck = true

  created(): void {
    this.getFieldSetting()
  }

  async getFieldSetting() {
    this.extendFieldList = await mfssp.get()
  }

  @Watch("data", { immediate: true })
  valueChange() {
    this.selectedRowKeys = []
    this.Rowkey = ""
  }

  clickRow(record){
    this.Rowkey = record.id
    this.currentRow = record
    console.log(this.currentRow)
    if(record.materialStatus == 1){
      this.canCheck = true
    } else {
      this.canCheck = false
    }
    this.selectedRowKeys = [record.id]
    // this.$emit('clickRow',record.id)
  }

  onSelectChange(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys;;
    if(selectedRowKeys.length == 1 ){
      const id = selectedRowKeys[0]
      const record = this.data.find(res => res.id === id)
      this.clickRow(record)
    }
  }

  testreload(){
    this.$emit('reloadEdit')
    this.testVisible = false
  }

  wareHousing(){
    const value = {
      ids: this.selectedRowKeys,
      isOrNot: 1
    } as WarehousingDTO
    siomsp.putInStorage(value).then(() =>{
      this.$emit('reloadEdit')
      this.$message.success(this.$t('page_material_warehousing_to_in_success'))
    })
  }

  view(){
    this.viewVisible = true
    const file = this.data.find(res => res.id === this.Rowkey)
    const data ={
      fileName: file.fileName,
      objectKey: file.fileObjectKey,
      contentType: file.contentType
    }
    this.handleShowFileInfo(data)
  }
  // 打开文件预览并立即展示标题
  handleShowFileInfo(record: any) {
    this.fileInfo = {}
    this.fileInfo = record
    const canPreview = canPreviewList
    let a = /.*\.(.*)$/
    let suffix = ''
    let name = record.originalFilename ? record.originalFilename : record.fileName
    if (name.indexOf('.') != -1) {
      suffix = a.exec(name)[1]
    } else {
      suffix = 'nc'
    }
    if (canPreview.includes(suffix.toLowerCase())) {
      this.showFileInfo = true
      this.previewEncode = 'UTF-8'
      this.previewMode = 'image'
      this.handleDownload(record, true)
    } else {
      this.handleDownload(record)
      this.setContent('', false)
      this.hiddenFileInfo()
    }
  }
  // 下载或预览文件，readOnly：true 预览，false 下载
  handleDownload(data: any, readOnly?: boolean) {
    if (readOnly) {
      this.setContent('', true)
    }
    let a = /.*\.(.*)$/
    let suffix = ''
    if (data.fileName.indexOf('.') != -1) {
      suffix = a.exec(data.fileName)[1]
    } else {
      suffix = 'nc'
    }
    if (suffix.toLowerCase() === 'pdf' && data.contentType === 'application/octet-stream') {
      data.contentType = 'application/pdf'
    }
    downloadGET(data.objectKey, data.objectKey, data.contentType).then((res: any) => {
      this.txtBlob = res
      if (readOnly) { // 预览
        this.filePreview(res, data)
      } else { // 下载
        downloadFile(res, data.originalFilename || data.fileName)
      }
    }, (err) => {
      this.setContent('', false)
    })
  }
  async filePreview(content: any, file: any) {
    let url: any
    let a = /.*\.(.*)$/
    let suffix = ''
    let name = file.originalFilename ? file.originalFilename : file.fileName
    if (name.indexOf('.') != -1) {
      suffix = a.exec(name)[1]
    } else {
      suffix = 'nc'
    }
    if (!canPreviewList.includes(suffix.toLowerCase())) {
      // 直接下载
      downloadFile(content, file.originalFilename || file.fileName)
    } else {
      for (let key in previewMode) {
        previewMode[key].map(async (item)=>{
          if(suffix.toLowerCase() === item) {
            this.previewMode = key
            switch (key) {
              case 'text':
                let result: any = await readAsText(content, this.previewEncode)
                this.setContent(result, false)
                break
              case 'image':
                url = await readAsDataURL(content)
                this.setContent(url, false)
                break
              case 'pdf':
                url = URL.createObjectURL(content)
                this.setContent(url, false)
                break
            }
          }
        })
      }
    }
  }
  // 设置预览的内容
  setContent(data: string, status: boolean) {
    this.content = data
    this.previewLoading = status
  }
  // 关闭文件预览
  hiddenFileInfo() {
    this.showFileInfo = false
  }
  render() {
    return (
      <div style="height: 100%">
        <div style="margin-bottom: 8px;">
          <a-button type="default" style="margin-right: 8px;" disabled={this.canCheck || this.selectedRowKeys.length !== 1} onClick={() => this.testVisible = true}>{ this.$t('page_material_warehousing_test')}</a-button>
          <a-button type="default" style="margin-right: 8px;" disabled={!this.Rowkey || this.selectedRowKeys.length !== 1 || !this.currentRow.isRead}  onClick={() => this.view()}>{ this.$t('page_material_warehousing_view_report')}</a-button>
          <a-button type="default" disabled={this.canCheck || this.selectedRowKeys.length === 0} onClick={() => this.wareHousing()}>{ this.$t('page_material_warehousing_temporary_storage')}</a-button>
        </div>
        <div style="height:calc(100% - 40px); box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff">
          <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            rowKey="id"
            scroll={{ y: this.height, x: 2350 }}
            row-selection={{
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange,
              getCheckboxProps: record => ({
                props: {
                  disabled: record.materialStatus == 1
                },
              }),
            }}
            selectRowKey={this.Rowkey}
            customRow={(record) => {
              return {
                on: { // 事件
                  click: () => this.clickRow(record),      // 点击行
                },
              };
           }}
          >
          </ml-table>
        </div>
        <Test currentRow={this.currentRow} visible={this.testVisible} onClose={() => this.testVisible = false} onReload={() => this.testreload()}></Test>
        <view-sheet
          visible={this.viewVisible}
          onClose={() => this.viewVisible = false}
          onReload={() => this.viewVisible = false}
          info={this.fileInfo}
          content={this.content}
          previewMode={this.previewMode}>
        </view-sheet>
      </div>
    )
  }
}
